<template>
  <header class="header">
    <!-- _/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/
        _/                                                                                                                    _/
        _/      事業者共通ヘッダ                                                                                              _/
        _/                                                                                                                    _/
    _/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/-->
    <div class="trial" v-if="isMobile && trial">電帳法オプション体験版</div>
    <div class="header-top">
      <div class="inner">
        <div class="header-left">
          <p class="site-title">
            <img
              src="@/assets/images/TDSDC/logo_tatsuzin.png"
              width="88"
              height="21"
              alt="TATSUZIN"
              @click="$redirect({ name: 'STFMFM02C29' })"
            />
          </p>
        </div>
        <div v-if="!isMobile && trial" class="header-left">
          <span class="data-label">{{ trialMessage }}</span>
        </div>
        <div class="header-right">
          <div v-if="!isMobile" class="user-menu">
            <button class="btn-user-menu" type="button">
              <span class="btn-user-name">{{ userName }}</span>
              &ensp;様
            </button>
            <div class="user-menu-nav">
              <ul>
                <li>
                  <a href="#" @click="operationGuide">運用ガイド</a>
                </li>
                <li>
                  <a
                    v-if="this.$cookies.get('isBopLogin') == 'true'"
                    href="#"
                    @click="logout"
                    >ログアウト</a
                  >
                  <span v-else>ログアウト</span>
                </li>
                <li>
                  <span>Version.{{ version }}</span>
                </li>
              </ul>
            </div>
          </div>
          <div v-if="isMobile"  @click.stop="(e)=>{handleActionButtonClick(e)}" class="user-menu">
            <button class="btn-user-menu" type="button">
              <span class="btn-user-name">{{ userName }}</span>
              &ensp;様
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- _/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/
        _/                                                                                                                    _/
        _/      事業者処理遷移ヘッダ                                                                                          _/
        _/                                                                                                                    _/
    _/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/-->
    <div class="header-bottom">
      <nav class="step-nav inner"></nav>
    </div>
    <LogoutConfirmDialog
      :isShow="isLogoutConfirmDialogShow"
      @confirm="confirm"
      @cancel="cancel"
    ></LogoutConfirmDialog>
    <div
      class="mask"
      v-if="showMask"
      @touchmove.prevent
      @click="closeMask('showMask')"
    >
      <div  :style="dropMeauPositon" class="user-menu-nav po-ab">
        <ul>
          <li>
            <a href="#" @click="operationGuide">運用ガイド</a>
          </li>
          <li>
            <a
              v-if="this.$cookies.get('isBopLogin') == 'true'"
              href="#"
              @click="logout"
              >ログアウト</a
            >
            <span v-else>ログアウト</span>
          </li>
          <li>
            <span>Version.{{ version }}</span>
          </li>
        </ul>
      </div>
    </div>
  </header>
</template>

<script>
import { mapMutations } from "vuex";
import Common from "@/util/common.js";
import LogoutConfirmDialog from "@/components/LogoutConfirmDialog.vue";
import {
  API_BopHeader,
  API_BopSignout,
} from "@/api/Modules/CM04/STDSCM04C00.js";

export default {
  name: "BusinessHeader",
  props: {
    menuflg: String,
  },
  components: {
    LogoutConfirmDialog,
  },
  data() {
    return {
      publicPath: process.env.BASE_URL,
      userName: "", // ログイン者名
      version: 0, // バージョン
      trialVersion: 0, // 体験版
      isLogoutConfirmDialogShow: false,
      isMobile: Common.isMobile(),
      showMask: false,
      dropMeauPositon:{
        right:0,
        top:0
      }
    };
  },
  created() {},
  mounted() {
    // this.isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    this.processDialogue(false);
    this.fetchMaintenance("");
    // 事業者共通ヘッダ情報取得を取得する
    API_BopHeader().then((response) => {
      this.userName = response.basicInfo.userName;
      this.trialVersion = response.basicInfo.availableDays;
      this.setBopUserName(response.basicInfo.customerName);
      this.setCurrentUserName(response.basicInfo.tatsuzinID);
      this.version = response.version;
      if (this.$cookies.get("bopPreOcclusionFlag")) {
        this.setCloseType(response.closeType);
        this.fetchMaintenance(response.maintenance);
      }
    });
  },
  computed: {
    // **********************************************
    // *  体験版表示・非表示
    // **********************************************
    trial() {
      return this.trialVersion == 0 ? false : true;
    },
    trialMessage() {
      return Common.getMessage("MTCL2071", [this.trialVersion]);
    },
  },
  methods: {
    ...mapMutations("businessModule", [
      "setBopUserName",
      "setCurrentUserName",
      "fetchMaintenance",
      "setCloseType",
      "processDialogue"
    ]),
    // **********************************************
    // * 運用ガイド
    // **********************************************
    operationGuide() {
      window.open(
        Common.getSettingsValue("BopOperationGuideUrl"),
        "_blank",
        "width=1240,height=760,menubar=no,location=no,resizable=yes,scrollbars=yes,status=no"
      );
    },
    // **********************************************
    // * ログアウト
    // **********************************************
    logout() {
      this.isLogoutConfirmDialogShow = true;
    },
    // **********************************************
    // * ログアウト確認
    // **********************************************
    confirm() {
      API_BopSignout()
        .then((response) => {
          // 成功の場合
          if (_.eq(response.result, "0000")) {
            // Sessionクリア
            this.$cookies.remove("SessionID");
            this.$cookies.remove("bopPreOcclusionFlag");
            if (sessionStorage.getItem("toRedirectUrl")) {
              let url = sessionStorage.getItem("toRedirectUrl");
              sessionStorage.getItem("toRedirectUrl");
              window.location.href = url;
            } else {
              let url = Common.getSettingsValue("BopPortalLoginUrl");
              window.location.href = `${url}`;
            }
          } else {
            let isOidc = Number(sessionStorage.getItem("isOidc"));
            if (isOidc == 1) {
              this.$router.push({
                name: "STDSCM04C07",
                state: {
                  message: Common.getMessage(response.errorCD, []),
                },
              });
            } else {
              this.$router.push({
                name: "STDSCM04C06",
                state: {
                  message: "ログアウト失敗",
                },
              });
            }
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    // **********************************************
    // * ログアウトキャンセル
    // **********************************************
    cancel() {
      // 遷移チェック：「キャンセル」
      this.isLogoutConfirmDialogShow = false;
    },
    closeMask(key) {
      this[key] = false;
    },
    handleActionButtonClick(e) {
      let offsetTop = e.currentTarget.getBoundingClientRect().top
      let headerPaddingRight = 20
      this.dropMeauPositon.top = offsetTop +  44  + "px"
      this.dropMeauPositon.right = headerPaddingRight + "px"
      this.showMask = true
    },
  },
};
</script>

<style scoped>
.mt-13px {
  margin-top: 13px !important;
}

.header > .header-top .trial {
  background-color: #333;
  color: #fff;
  text-align: center;
  padding: 10px;
}
.po-ab{
  position: absolute;
}
.user-menu > .btn-user-menu>.btn-user-name {
  max-width: 1000px;
}
@media (max-width: 768px) {
  .trial {
    background-color: #333;
    color: #fff;
    text-align: center;
    padding: 10px;
    font-weight: 700;
    font-size: 1.3rem;
  }
  .user-menu{
    border-left: none;
    margin-left: 0;
  }
  .user-menu > .btn-user-menu>.btn-user-name {
    max-width: calc(100svw - 230px)
  }
}
</style>
